export const MAX_BRANCH_NESTING_DEPTH = 5;
